import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import React from "react";
import {
	BooleanInput,
	TextInput,
	maxLength,
	required,
	useGetIdentity,
	useTranslate,
} from "react-admin";

const PositionInput = ({ disabled = false }) => {
	const translate = useTranslate();
	const { identity } = useGetIdentity();
	const validateThesis = [required(), maxLength(19)];
	const neutralThesisName =
		identity?.settings?.vote?.neutralThesisName ||
		translate("resources.groups.fields.neutral_thesis");

	return (
		<Stack direction={"column"}>
			<Stack direction={"row"} mb={0} mt={3} spacing={1}>
				<TextInput
					source="pro_thesis"
					placeholder={translate("resources.groups.placeholder.pro_thesis")}
					variant="outlined"
					required
					validate={validateThesis}
					disabled={disabled}
				/>
				<TextInput
					source="against_thesis"
					variant="outlined"
					required
					validate={validateThesis}
					disabled={disabled}
				/>
				{identity?.settings?.vote?.neutralThesis === true && (
					<BooleanInput
						source="has_neutral_thesis"
						fullwidth="true"
						label={translate("resources.groups.fields.has_neutral_thesis", {
							thesis: `"${neutralThesisName}"`,
						})}
						defaultValue={true}
						disabled={disabled}
					/>
				)}
			</Stack>
			{identity?.settings?.vote?.neutralThesis === true && (
				<Box mb={3}>
					<Alert severity="info">
						{translate("resources.groups.labels.neutral_thesis_info", {
							thesis: `"${neutralThesisName}"`,
						})}
					</Alert>
				</Box>
			)}
		</Stack>
	);
};

export default PositionInput;
